/* eslint-disable @tencent/i18next/no-literal-string */

// prettier-ignore
const num = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];

// prettier-ignore
const numPrefix = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'];

// prettier-ignore
const zhcn = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十'];

// prettier-ignore
const zhhk = ['壹', '貳', '叁', '肆', '伍', '陸', '柒', '捌', '玖', '拾', '拾壹', '拾貳', '拾叁', '拾肆', '拾伍', '拾陸', '拾柒', '拾捌', '拾玖', '貳拾'];

// prettier-ignore
const enUppercase = ['ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN', 'ELEVEN', 'TWELVE', 'THIRTEEN', 'FOURTEEN', 'FIFTEEN', 'SIXTEEN', 'SEVENTEEN', 'EIGHTEEN', 'NINETEEN', 'TWENTY'];

// prettier-ignore
const enLowercase = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty'];

// prettier-ignore
const enTitlecase = ['One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen', 'Twenty'];

// TODO: numPrefix, num 目前顺序需要固定
const formatList = [numPrefix, num, zhcn, zhhk, enLowercase, enTitlecase, enUppercase].map((serialTexts) => ({
  serialTexts,
  regexp: new RegExp(`(${serialTexts.join('|')})`),
}));

function createFormatter(text: string, reg: RegExp, serialTexts: string[]) {
  return function Formatter(index: number): string {
    return text.replace(reg, serialTexts[index]);
  };
}

export const isSerial = (text: string): boolean => {
  for (const { regexp } of formatList) {
    if (regexp.test(text)) {
      return true;
    }
  }
  return false;
};

export const getSerialFormatter = (text: string): ReturnType<typeof createFormatter> | null => {
  for (const { serialTexts, regexp } of formatList) {
    if (regexp.test(text)) {
      return createFormatter(text, regexp, serialTexts);
    }
  }
  return null;
};

// export const isSerialNumber = (text: string): boolean => !isNaN(+text) || list.includes(text);
